<template>
  <ul class="values">
    <li class="values__item">
      <span class="values__item__text">{{ $t(`${namespace}.averageTicket`) }}</span>
      <span class="values__item__value">{{ data.averageFare | currencyBRL }}</span>
    </li>

    <li class="values__item">
      <span class="values__item__text">{{ $t(`${namespace}.rides`) }}</span>
      <span class="values__item__value">
        <span v-if="data.amount < 10000">{{ data.amount | formatNumber }}</span>
        <span v-else>
          <v-tooltip slot="append" top>
            <span slot="activator">
              {{ data.amount | convertNumberToStringNotation }}
            </span>
            <span>{{ data.amount | formatNumber }}</span>
          </v-tooltip>
        </span>
      </span>
    </li>

    <li class="values__item">
      <span class="values__item__text">{{ $t(`${namespace}.totalSpend`) }}</span>
      <span class="values__item__value">
        <span v-if="data.totalFare < 10000">{{ data.totalFare | currencyBRL }}</span>
        <span v-else>
          <v-tooltip slot="append" top>
            <span slot="activator">
              {{ currency }} {{ data.totalFare | convertNumberToStringNotation }}
            </span>
            <span>{{ data.totalFare | currencyBRL }}</span>
          </v-tooltip>
        </span>
      </span>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'Values',
  props: {
    data: {
      type: Object
    }
  },
  computed: {
    currency () {
      const val = 0
      return val.toLocaleString(
        'pt-br', {
          maximumFractionDigits: 2,
          minimumFractionDigits: 2,
          style: 'currency',
          currency: 'BRL'
        }
      ).replace(/(.+)\s+?(.+)/, '$1')
    }
  },
  data () {
    return {
      namespace: 'Components.Performance'
    }
  }
}
</script>

<style lang="scss" scoped>
.values {
  display: flex;
  flex-direction: row;
  list-style-type: none;
  margin: 0;
  padding: 0;
}

.values__item {
  display: flex;
  flex-direction: column;

  + .values__item {
    margin-left: 12px;

    @media (min-width: 768px) {
      margin-left: 26px;
    }
  }
}

.values__item__value,
.values__item__text {
  color: $gray-7;
  line-height: 1;
}

.values__item__text {
  font-size: 11px;
  margin-bottom: 8px;

  @media (min-width: 768px) {
    font-size: 14px;
  }
}

.values__item__value {
  font-family: 'Montserrat', sans-serif;
  font-size: 16px;
  font-weight: 800;

  @media (min-width: 768px) {
    font-size: 22px;
  }
}
</style>
